import React from "react";
import { config } from "../../app/utils/config";
import { Localize } from "../../app/lang/langs";
import styles from "./EnvBadge.module.css";

// Permanent marker for any environment that is not production. Preprod is served from
// the same codebase, styled identically and reached with the same credentials as the
// live app, so the only thing separating "I am testing" from "I am editing real payroll
// data" is the hostname in the address bar. This makes the difference impossible to miss.
//
// config.env comes from detectEnv(), which reads window.location.hostname:
// ppdv365 -> PREPROD, v365 -> PROD, anything else -> STAG. So this needs no build flag
// and no per-branch edit; the same bundle marks itself correctly wherever it is served.
//
// PROD renders null — nothing is added to the DOM on the live app at all.
const ENV_STYLES = {
    PREPROD: { className: styles.preprod, labelKey: "ENV_PREPROD" },
    STAG: { className: styles.stag, labelKey: "ENV_STAG" },
};

export default function EnvBadge() {
    const env = ENV_STYLES[config.env];
    if (!env) return null;

    const label = Localize(env.labelKey);

    return (
        <>
            <div className={`${styles.strip} ${env.className}`} aria-hidden="true" />
            {/* role=status rather than alert: it states a standing fact about the page and
                must not interrupt whatever a screen reader is currently announcing. */}
            <div className={`${styles.pill} ${env.className}`} role="status">
                {label}
            </div>
        </>
    );
}
